import React from "react";
import { Modal } from "react-bootstrap";

const ReusableModal = ({ show, onHide, title, children, size = "" }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size={size}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
        <button
          type="button"
          className="close"
          aria-label="Close"
          onClick={onHide}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </Modal.Header>
      {children}
    </Modal>
  );
};

export default ReusableModal;
